// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { WMComponent } from '@front/webmobile/Views/Components/WMComponent';
import { AccountWidgetDragAndDropViewModel } from '../../ViewModels/AccountWidgetDragAndDropViewModel';
import React from 'react';
export class AccountWidgetDragAndDrop extends WMComponent {
    constructor(props) {
        super(props, AccountWidgetDragAndDropViewModel);
    }
    render() {
        if (isNullOrUndefined(this.props.typePointer)) {
            return null;
        }
        const { HeaderText, firstValue, firstValueColor, secondValue, secondValueColor, left, top } = this.state;
        return (React.createElement("div", { className: "accountWidget-DragAndDrop", style: { position: 'absolute', cursor: 'default', left: left + 'px', top: top + 'px' } },
            React.createElement("div", { className: "accountWidget-DragAndDrop-header" }, HeaderText),
            React.createElement("div", { className: "accountWidget-DragAndDrop-value" },
                React.createElement("div", { className: firstValueColor }, firstValue),
                secondValue && (React.createElement(React.Fragment, null,
                    React.createElement("div", null, "/"),
                    React.createElement("div", { className: secondValueColor }, secondValue))))));
    }
}
